module.exports = __webpack_public_path__ + "static/media/js.b2bb28d7.svg";